import { render, staticRenderFns } from "./Workload.vue?vue&type=template&id=9c2c3cac&scoped=true&"
import script from "./workload.js?vue&type=script&lang=js&"
export * from "./workload.js?vue&type=script&lang=js&"
import style0 from "./Workload.vue?vue&type=style&index=0&id=9c2c3cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2c3cac",
  null
  
)

export default component.exports